import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoTab from 'eco-design/elements/eco-tab';
import { useEffect, useState } from 'react';
import {
    Tab1Icon1,
    Tab1Icon2,
    Tab1Icon3,
    Tab1Icon4,
    Tab1Icon5,
    Tab1Icon6,
    Tab1Icon7,
    Tab1Icon8,
    Tab2Icon1,
    Tab2Icon2,
    Tab2Icon3,
    Tab2Icon4,
    Tab2Icon5,
    Tab2Icon6,
    Tab2Icon7,
    Tab2Icon8,
    Tab3Icon1,
    Tab3Icon2,
    Tab3Icon3,
    Tab3Icon4,
    Tab3Icon5,
    Tab3Icon6,
    Tab3Icon7,
    Tab4Icon1,
    Tab4Icon2,
    Tab4Icon3,
    Tab4Icon4,
    Tab4Icon5,
    Tab4Icon6,
    Tab5Icon1,
    Tab5Icon2,
    Tab5Icon3,
    Tab5Icon4,
    Tab5Icon5,
    Tab5Icon6,
} from './config';
import styles from './index.module.scss';

export default function TabSwriper1() {
    const { t } = useLang('dp3.landing.tabSwriper1');

    const [activeTab, setActiveTab] = useState('tab1');

    const [selectIndex, setSelectIndex] = useState(0);
    const splitWithBracket = (str: string) => {
        const regex = /^([^()]*)(\(.*\))?$/;
        const match = str.match(regex);

        if (match) {
            const mainPart = match[1].trim() || str;
            const bracketPart = match[2] || '';

            return { mainPart, bracketPart };
        }

        return { mainPart: str, bracketPart: '' };
    };

    const tabItems = [
        {
            tabValue: 'tab1',
            tabLabel: t('tab_label1'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1749870688062/pc_tab1.png',
            pad: '',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1749870686872/m_tab1.png',
            list: [
                {
                    title: t('item1_title1'),
                    ...splitWithBracket(t('item1_title1')),
                    desc: t.rich('item1_desc1', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab1Icon1 />,
                },
                {
                    title: t('item1_title2'),
                    ...splitWithBracket(t('item1_title2')),
                    desc: t.rich('item1_desc2', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab1Icon2 />,
                },
                {
                    title: t('item1_title3'),
                    ...splitWithBracket(t('item1_title3')),
                    desc: t.rich('item1_desc3', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab1Icon3 />,
                },
                {
                    title: t('item1_title4'),
                    ...splitWithBracket(t('item1_title4')),
                    desc: t.rich('item1_desc4', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab1Icon4 />,
                },
                {
                    title: t('item1_title5'),
                    ...splitWithBracket(t('item1_title5')),
                    desc: t.rich('item1_desc5', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab1Icon5 />,
                },
                {
                    title: t('item1_title6'),
                    ...splitWithBracket(t('item1_title6')),
                    desc: t.rich('item1_desc6', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab1Icon6 />,
                },
                {
                    title: t('item1_title7'),
                    ...splitWithBracket(t('item1_title7')),
                    desc: t.rich('item1_desc7', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab1Icon7 />,
                },
                {
                    title: t('item1_title8'),
                    ...splitWithBracket(t('item1_title8')),
                    desc: t.rich('item1_desc8', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab1Icon8 />,
                },
            ],
        },
        {
            tabValue: 'tab2',
            tabLabel: t('tab_label2'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1749870688239/pc_tab2.png',
            pad: '',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1749870686685/m_tab2.png',
            list: [
                {
                    title: t('item2_title1'),
                    ...splitWithBracket(t('item2_title1')),
                    desc: t.rich('item2_desc1', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab2Icon1 />,
                },
                {
                    title: t('item2_title2'),
                    ...splitWithBracket(t('item2_title2')),
                    desc: t.rich('item2_desc2', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab2Icon2 />,
                },
                {
                    title: t('item2_title3'),
                    ...splitWithBracket(t('item2_title3')),
                    desc: t.rich('item2_desc3', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab2Icon3 />,
                },
                {
                    title: t('item2_title4'),
                    ...splitWithBracket(t('item2_title4')),
                    desc: t.rich('item2_desc4', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab2Icon4 />,
                },
                {
                    title: t('item2_title5'),
                    ...splitWithBracket(t('item2_title5')),
                    desc: t.rich('item2_desc5', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab2Icon5 />,
                },
                {
                    title: t('item2_title6'),
                    ...splitWithBracket(t('item2_title6')),
                    desc: t.rich('item2_desc6', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab2Icon6 />,
                },
                {
                    title: t('item2_title7'),
                    ...splitWithBracket(t('item2_title7')),
                    desc: t.rich('item2_desc7', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab2Icon7 />,
                },
                {
                    title: t('item2_title8'),
                    ...splitWithBracket(t('item2_title8')),
                    desc: t.rich('item2_desc8', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab2Icon8 />,
                },
            ],
        },
        {
            tabValue: 'tab3',
            tabLabel: t('tab_label3'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1749870687237/pc_tab5.png',
            pad: '',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1749870687058/m_tab3.png',
            list: [
                {
                    title: t('item3_title1'),
                    ...splitWithBracket(t('item3_title1')),
                    desc: t.rich('item3_desc1', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab3Icon1 />,
                },
                {
                    title: t('item3_title2'),
                    ...splitWithBracket(t('item3_title2')),
                    desc: t.rich('item3_desc2', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab3Icon2 />,
                },
                {
                    title: t('item3_title3'),
                    ...splitWithBracket(t('item3_title3')),
                    desc: t.rich('item3_desc3', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab3Icon3 />,
                },
                {
                    title: t('item3_title4'),
                    ...splitWithBracket(t('item3_title4')),
                    desc: t.rich('item3_desc4', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab3Icon4 />,
                },
                {
                    title: t('item3_title5'),
                    ...splitWithBracket(t('item3_title5')),
                    desc: t.rich('item3_desc5', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab3Icon5 />,
                },
                {
                    title: t('item3_title6'),
                    ...splitWithBracket(t('item3_title6')),
                    desc: t.rich('item3_desc6', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab3Icon6 />,
                },
                {
                    title: t('item3_title7'),
                    ...splitWithBracket(t('item3_title7')),
                    desc: t.rich('item3_desc7', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab3Icon7 />,
                },
            ],
        },
        {
            tabValue: 'tab4',
            tabLabel: t('tab_label4'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1749870687428/pc_tab4.png',
            pad: '',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1749870687653/m_tab4.png',
            list: [
                {
                    title: t('item4_title1'),
                    ...splitWithBracket(t('item4_title1')),
                    desc: t.rich('item4_desc1', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab4Icon1 />,
                },
                {
                    title: t('item4_title2'),
                    ...splitWithBracket(t('item4_title2')),
                    desc: t.rich('item4_desc2', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab4Icon2 />,
                },
                {
                    title: t('item4_title3'),
                    ...splitWithBracket(t('item4_title3')),
                    desc: t.rich('item4_desc3', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab4Icon3 />,
                },
                {
                    title: t('item4_title4'),
                    ...splitWithBracket(t('item4_title4')),
                    desc: t.rich('item4_desc4', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab4Icon4 />,
                },
                {
                    title: t('item4_title5'),
                    ...splitWithBracket(t('item4_title5')),
                    desc: t.rich('item4_desc5', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab4Icon5 />,
                },
                {
                    title: t('item4_title6'),
                    ...splitWithBracket(t('item4_title6')),
                    desc: t.rich('item4_desc6', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab4Icon6 />,
                },
            ],
        },
        {
            tabValue: 'tab5',
            tabLabel: t('tab_label5'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1749870687838/pc_tab3.png',
            pad: '',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1749870825421/m_tab5.png',
            list: [
                {
                    title: t('item5_title1'),
                    ...splitWithBracket(t('item5_title1')),
                    desc: t.rich('item5_desc1', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab5Icon1 />,
                },
                {
                    title: t('item5_title2'),
                    ...splitWithBracket(t('item5_title2')),
                    desc: t.rich('item5_desc2', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab5Icon2 />,
                },
                {
                    title: t('item5_title3'),
                    ...splitWithBracket(t('item5_title3')),
                    desc: t.rich('item5_desc3', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab5Icon3 />,
                },
                {
                    title: t('item5_title4'),
                    ...splitWithBracket(t('item5_title4')),
                    desc: t.rich('item5_desc4', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab5Icon4 />,
                },
                {
                    title: t('item5_title5'),
                    ...splitWithBracket(t('item5_title5')),
                    desc: t.rich('item5_desc5', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab5Icon5 />,
                },
                {
                    title: t('item5_title6'),
                    ...splitWithBracket(t('item5_title6')),
                    desc: t.rich('item5_desc6', {
                        e: (tx: string) => <span className="num">{tx}</span>,
                    }),
                    icon: <Tab5Icon6 />,
                },
            ],
        },
    ];

    const tipKeys = ['tip_desc1', 'tip_desc2'];
    const [activeItem, setActiveItem] = useState(tabItems[selectIndex]);

    // 使用布尔数组记录每个标签的点击状态
    const [clickedTabs, setClickedTabs] = useState<boolean[]>(new Array(tabItems.length).fill(false));

    const onTabChange = (item: any, index: number) => {
        setActiveTab(item.tabValue);
        setSelectIndex(index);
        setActiveItem(item);
        console.log('tabItems', tabItems);

        // 如果该标签未被点击过
        if (!clickedTabs[index]) {
            // 更新点击状态
            const newClickedTabs = [...clickedTabs];
            newClickedTabs[index] = true;
            setClickedTabs(newClickedTabs);

            // 触发GTM事件
            gtm.push({
                event: 'uaEvent',
                event_name: 'tab_click',
                list_name: `${t('title')}`,
                button_name: item.tabLabel,
                __btn_id1: `${styles.TabSwriper1} .item-${index + 1}`,
                __btn_id2: item.tabLabel,
                __btn_type: 'text',
            });
        }
    };
    const [load, setLoad] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const secne = AniContainer.create({
                triggerElement: '#page-section1JP',
                triggerHook: 1,
                onEnter: () => setLoad(true),
            });
            return () => {
                secne.destroy();
            };
        }
    }, []);
    return (
        <div className={`page-tabSwriper1 ${styles.TabSwriper1} GtmModuleData-section`} id='page-tabSwriper1' data-section-id={'dp3-TabSwriper1'} data-section-title={t('title')}>
            <EcoSectionCommon title={t('title')} desc={t('desc')} subTitle={t('')} />
            <EcoSpaceSmall />
            <div className={`eco-content ${styles.TabSwriper1}`}>
                <div className="tab-swriper-container">
                    <div className="tab-content">
                        <div className="content-image">
                            {load && <EcoImg pc={activeItem.pc} h5={activeItem.h5} />}
                        </div>
                        <div className={`content-items tab-${selectIndex}`}>
                            {(tabItems[selectIndex].list || []).map((item: any, index: number) => (
                                <div key={index} className="item">
                                    <div className="icon">{item.icon}</div>
                                    <div className="text">
                                        {/* pad 和 h5 才显示 */}
                                        <div className="bracket">{item.bracketPart}</div>
                                        <div className="main">{item.mainPart}</div>
                                        {/* pc 才显示 */}
                                        <div className="title">{item.title}</div>
                                        <div className="desc">{item.desc}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="tabs">
                        {/* {tabs.map((tab) => (
                            <button key={tab.id} className={`tab-button ${activeTab === tab.id ? 'active' : ''}`} onClick={() => setActiveTab(tab.id)}>
                                {tab.label}
                            </button>
                        ))} */}
                        <EcoTab activeKey={activeTab} items={tabItems} onChange={onTabChange} />
                    </div>
                </div>
                {/* <EcoTabSwiper items={items} /> */}

                <div className="tip-container">
                    {tipKeys.map((key, index) => (
                        <div className="tip" key={index}>
                            {t.rich(key, {
                                sup: (tx: string) => <span className="number">{tx}</span>,
                            })}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
